import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, isRef as _isRef, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/jianyan_ic_saoma@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-27672259"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_h" }, null, -1))
const _hoisted_3 = { class: "page_lx_item padding" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "检验类型", -1))
const _hoisted_5 = { class: "page_lx_item_is" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_h" }, null, -1))
const _hoisted_8 = { class: "page_content" }
const _hoisted_9 = { class: "page_content_title" }
const _hoisted_10 = { class: "page_content_item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "合格数量", -1))
const _hoisted_12 = { class: "page_content_item_i" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "page_content_item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不良数量", -1))
const _hoisted_16 = { class: "page_content_item_i" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不良工装", -1))
const _hoisted_19 = { class: "page_content_item_is" }
const _hoisted_20 = {
  key: 1,
  class: "page_content_sm"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "扫描工装", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "page_lx" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不良原因", -1))
const _hoisted_26 = { class: "page_lx_item_i" }
const _hoisted_27 = { class: "page_remark" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_zw" }, null, -1))
const _hoisted_29 = { class: "page_footer" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_31 = [
  _hoisted_30
]

import { ref, reactive, onMounted, nextTick, watch } from 'vue'
    import { useRoute, useRouter } from "vue-router"
    import { createJY } from '@/apis/QualityAPI'
    import { Toast } from 'vant'
    import { QRCodeType, Attribute } from '@/enum'
    import { queryById, getListByCondition, checkAllList, getBarcodeContent } from '@/apis/WorkOrderAPI'
    import VWorkOrderInfo from '@/components/common/WorkOrderInfo.vue'
    import Tooling from '@/components/common/Tooling.vue'
    import * as dd from "dingtalk-jsapi";

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()

    const router = useRouter()

    // 区分扫码
    let index = ref<string>()

    // 控制不良显示隐藏
    const isShow = ref<boolean>(false)

    let gzShow = ref<boolean>(false)

    // 控制扫码显示隐藏
    const openCode = ref<boolean>(false)

    // 工装弹框显示隐藏
    const show = ref<boolean>(false)

    // 不良原因弹框显示隐藏
    const show1 = ref<boolean>(false)

    // 工装下拉数据
    const columns: any = ref([])

    // 不良原因下拉数据
    const columns1: any = ref([])

    // 工单详情数据
    let info: any = ref({})

    // 工装器具详情
    let infos: any = ref({})

    // 检验提交数据
    let data: any = reactive({
        id: '',       // 工装id
        qualified: '',       // 合格
        unqualified: '',      // 不合格
        defectiveTooling: '',// 不合格工装
        defectiveToolingName: '',   // 不合格工装名称
        defectDescription: '',// 不合格说明
        defectDescriptionName: '',  // 不良原因名称
        type: '1'             // 检验类型
    })

    let remark = ref<string>('')    // 备注

    // 检验类型
    const typeList: any = ref([])

    const close1 = () => {
        gzShow.value = false
    }

    // 获取工装数据
    const getValue = (item: any) => {
        data.defectiveTooling = item.id
        data.defectiveToolingName = item.code
        gzShow.value = false
    }

    // 获取扫码值
    const onDecode = (datas: string[]): void => {
        if (index.value === '1') {
            getBarcodeContent({
                barcode: datas[0]
            }).then(resa => {
                if (resa.code === 200 && resa.data.barcodeType === QRCodeType.GZ) {
                    getListByCondition({
                        id: resa.data.id
                    }).then(res => {
                        if (res.code === 200 && res.data && res.data.length !== 0) {
                            if (info.value.type === 2) {    // 返工返修
                                if (res.data[0].smodelLabel === Attribute.BF) {
                                    if (res.data[0].status !== 0) {
                                        data.defectiveTooling = res.data[0].id
                                        data.defectiveToolingName = res.data[0].code
                                    } else {
                                        Toast.fail({ message: '扫描的工装状态不能为已报废' })
                                    }
                                } else {
                                    Toast.fail({ message: '只能扫描报废属性的工装' })
                                }
                            } else {
                                if (res.data[0].smodelLabel === Attribute.BL || res.data[0].smodelLabel === Attribute.BF) {
                                    if (res.data[0].status !== 0) {
                                        data.defectiveTooling = res.data[0].id
                                        data.defectiveToolingName = res.data[0].code
                                    } else {
                                        Toast.fail({ message: '扫描的工装状态不能为已报废' })
                                    }
                                } else {
                                    Toast.fail({ message: '只能扫描不良或者报废属性的工装' })
                                }
                            }
                        }
                    })
                } else {
                    Toast.fail({ message: '请扫描正确的工装码' })
                }
            })
        } else if (index.value === '2') {
            getBarcodeContent({
                barcode: datas[0]
            }).then(res => {
                if (res.code === 200 && res.data.barcodeType === QRCodeType.GZ) {
                    data.qualified = ''
                    data.unqualified = 0
                    data.defectiveTooling = ''
                    data.defectiveToolingName = ''
                    data.defectDescription = ''
                    data.defectDescriptionName = ''
                    data.type = '1'
                    typeList.value.forEach((item: any, index: number) => {
                        item.active = index === 0;
                    })
                    getListByConditions(res.data.id)
                } else {
                    Toast.fail({ message: '请扫描正确的工装码' })
                }
            })
        }
        nextTick(() => {
            openCode.value = false
        })
    }

    // 关闭扫码组件
    const closePopup = (): void => {
        openCode.value = false
    }

    // 确认选择工装
    const onConfirm = (value: any, index: any) => {
        data.defectiveTooling = value.id
        data.defectiveToolingName = value.text
        show.value = false
    }

    // 关闭工装弹框
    const onCancel = () => {
        show.value = false
    }

    // 确认选择不良原因
    const onConfirm1 = (value: any) => {
        data.defectDescription = value.id
        data.defectDescriptionName = value.text
        show1.value = false
    }

    // 关闭不良原因弹框
    const onCancel1 = () => {
        show1.value = false
    }

    // 打开工装
    const openGZ = () => {
        // show.value = true
        gzShow.value = true
    }

    // 继续检验
    const openSM = (type: string) => {
        if (type === '1') {     // 扫描工装
            index.value = type
            openCode.value = true
        } else if (type === '2') {     // 继续检验
            if (!data.qualified) {
                data.qualified = 0
            }
            if (!data.unqualified) {
                data.unqualified = 0
            }
            if (data.qualified === 0 && data.unqualified === 0) {
                return Toast({ message: '合格数量不能同时为0！', duration: 2000 })
            }
            if (data.unqualified > 0) {
                if (!data.defectiveTooling) return Toast.fail({ message: '不良工装不能为空！', duration: 2000 })
                if (!data.defectDescription) return Toast.fail({ message: '不良说明不能为空！', duration: 2000 })
            }
            let checkType: any;
            typeList.value.forEach((item: any) => {
                if (item.active) {
                    checkType = item.id
                }
            })
            createJY({
                workorderId: route.query.gdId,
                appliancesId: data.id,
                qualifiedNum: data.qualified,
                unqualifiedNum: data.unqualified,
                qualifiedApplianceId: data.defectiveTooling,
                checkInfo: data.defectDescription,
                checkType: checkType
            }).then(res => {
                if (res.code === 200) {
                    // 清空操作
                    data.qualified = ''
                    data.unqualified = 0
                    data.defectiveTooling = ''
                    data.defectiveToolingName = ''
                    data.defectDescription = ''
                    data.defectDescriptionName = ''
                    data.type = '1'
                    // 还原类型
                    typeList.value.forEach((item: any, index: number) => {
                        item.active = index === 0;
                    })

                    index.value = type

                    Toast.success({ message: '检验成功！', duration: 2000 })

                    setTimeout(() => {
                        openCode.value = true
                    }, 2000)
                }
            })
        }

    }

    // 打开不良原因
    const openBL = () => {
        show1.value = true
    }

    // 切换类型
    const clickTag = (index: number): void => {
        typeList.value.forEach((item: any, i: number) => {
            item.active = index === i;
        })
    }

    // 获取工单详情
    const queryByIds = () => {
        queryById(route.query.gdId)
            .then(res => {
                if (res.code === 200) {
                    info.value = res.data
                    let router: any = route.query.type
                    let title: string = ''
                    if (router == 1) {  // 巡线
                        title = '生产巡线'
                        typeList.value.push({ name: '巡线', id: '0', active: true })
                    } else if (router == 2) {  // 巡检
                        title = '品质检验'
                        typeList.value.push({ name: '巡检', id: '1', active: true })
                        if (res.data.status === 3) {    // 已检验状态才展示完工检验入口
                            typeList.value.push({ name: '完工检验', id: '2', active: false })
                        }
                    }
                    document.title = title
                    // 判断是否在钉钉内
                    if (dd.env.platform !== 'notInDingTalk') {
                        // 如果是钉钉登录，设置钉钉导航栏标题为router里meta标签里设置的title
                        dd.biz.navigation.setTitle({
                            title: title,
                            // @ts-ignore
                            onSuccess: (result: any) => {
                                console.log('设置钉钉title成功')
                            },
                            onFail: (err: any) => {
                                console.log('设置钉钉title失败')
                            }
                        })
                    }
                }
            })
    }

    // 查询工装器具详情
    const getListByConditions = (id: any): void => {
        getListByCondition({
            id
        }).then(res => {
            if (res.code === 200 && res.data && res.data.length !== 0) {
                infos.value = res.data[0]
                data.id = infos.value.id
            }
        })
    }

    // 不良原因数据
    const checkAllLists = () => {
        checkAllList({ bmodelCateType: '3' })
            .then(res => {
                if (res.code === 200 && res.data && res.data.length !== 0) {
                    res.data.forEach((item: any) => {
                        columns1.value.push({ text: item.combinationName, id: item.id })
                    })
                }
            })
    }

    // 查询不良/报废工装
    const getListByConditions1 = () => {
        getListByCondition({
            smodelLabel: `${Attribute.BL},${Attribute.BF}`
        }).then(res => {
            if (res.code === 200 && res.data && res.data.length !== 0) {
                res.data.forEach((item: any) => {
                    columns.value.push({ text: item.code, id: item.id })
                })
            }
        })
    }

    // 提交检验
    const submit = () => {
        if (!data.qualified) {
            data.qualified = 0
        }
        if (!data.unqualified) {
            data.unqualified = 0
        }
        if (data.qualified === 0 && data.unqualified === 0) {
            return Toast({ message: '合格数量不能同时为0！', duration: 2000 })
        }
        if (data.unqualified > 0) {
            if (!data.defectiveTooling) return Toast({ message: '不良工装不能为空！', duration: 2000 })
            if (!data.defectDescription) return Toast({ message: '不良原因不能为空！', duration: 2000 })
        }
        let checkType: any;
        typeList.value.forEach((item: any) => {
            if (item.active) {
                checkType = item.id
            }
        })
        createJY({
            workorderId: route.query.gdId,
            appliancesId: data.id,
            qualifiedNum: data.qualified,
            unqualifiedNum: data.unqualified,
            qualifiedApplianceId: data.defectiveTooling,
            checkInfo: data.defectDescription,
            remark: remark.value,
            checkType: checkType
        }).then(res => {
            if (res.code === 200) {
                Toast.success({ message: '检验成功！', duration: 2000, forbidClick: true })
                setTimeout(() => {
                    router.go(-1)
                }, 2000)
            }
        })
    }

    // 监听不良数量
    watch(() => data.unqualified, (news, old) => {
        isShow.value = news > 0;
        if (news > 0) {
            data.defectiveTooling = ''
            data.defectiveToolingName = ''
            data.defectDescription = ''
            data.defectDescriptionName = ''
        }
    }, { deep: true })

    onMounted(() => {
        queryByIds()
        getListByConditions(route.query.gzId)
        checkAllLists()
        getListByConditions1()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_v_ScanCode = _resolveComponent("v-ScanCode")!
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(VWorkOrderInfo, { info: _unref(info) }, null, 8, ["info"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["page_lx_item_is_i", { 'active': item.active }]),
            key: index,
            onClick: ($event: any) => (clickTag(index))
          }, [
            _createElementVNode("span", null, _toDisplayString(item.name), 1)
          ], 10, _hoisted_6))
        }), 128))
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(infos).cmodel1BigName) + " " + _toDisplayString(_unref(infos).code), 1),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).qualified) = $event)),
            type: "number",
            placeholder: "0"
          }, null, 512), [
            [_vModelText, _unref(data).qualified]
          ]),
          (_unref(info).umodel)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(info).umodel.name), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).unqualified) = $event)),
            placeholder: "0",
            type: "number"
          }, null, 512), [
            [_vModelText, _unref(data).unqualified]
          ]),
          (_unref(info).umodel)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(info).umodel.name), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      (isShow.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "page_content_item",
            onClick: openGZ
          }, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", {
                style: _normalizeStyle(_unref(data).defectiveToolingName ? 'color: #000;' : '')
              }, _toDisplayString(_unref(data).defectiveToolingName ? _unref(data).defectiveToolingName : '点击选择工装'), 5),
              _createVNode(_component_van_icon, {
                name: "arrow",
                color: "#999999",
                size: "18"
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (isShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", {
              class: "page_content_sm_box",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (openSM('1')))
            }, _hoisted_23)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_24, [
      (isShow.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "page_lx_item",
            onClick: openBL
          }, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("span", {
                style: _normalizeStyle(_unref(data).defectDescriptionName ? 'color: #000;' : '')
              }, _toDisplayString(_unref(data).defectDescriptionName ? _unref(data).defectDescriptionName : '点击选择不良原因'), 5),
              _createVNode(_component_van_icon, { name: "arrow" })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_27, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(remark) ? (remark).value = $event : remark = $event)),
        placeholder: "请输入检验备注说明信息，非必填"
      }, null, 512), [
        [_vModelText, _unref(remark)]
      ])
    ]),
    _hoisted_28,
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", {
        class: "page_footer_jx",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (openSM('2')))
      }, "继续检验"),
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "page_footer_tj",
        onClick: submit
      }, _hoisted_31)), [
        [_directive_preventReClick]
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: show1.value,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((show1).value = $event)),
      position: "bottom",
      round: "",
      style: { height: '40%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "选择不良原因",
          columns: columns1.value,
          onConfirm: onConfirm1,
          onCancel: onCancel1
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_v_ScanCode, {
      openCode: openCode.value,
      infos: ['请扫描工装码'],
      onClosePopup: closePopup,
      onOnDecode: onDecode
    }, null, 8, ["openCode"]),
    _createVNode(Tooling, {
      show: _unref(gzShow),
      attribute: _unref(info).type === 2 ? _unref(Attribute).BF : _unref(Attribute).BL + ',' + _unref(Attribute).BF,
      onClose: close1,
      onValue: getValue
    }, null, 8, ["show", "attribute"])
  ]))
}
}

})